import React from 'react';
import { routing } from '@utils/routing';
import { signets } from '../../assets/signets';
import { AppsIntegrationUnified } from '../AppsIntegrationUnified';
import { AppsKlaviyoSettings } from './AppsKlaviyoSettings';
export const AppsKlaviyo = () => {
    return (React.createElement(AppsIntegrationUnified, { appId: "klaviyo", name: "Klaviyo", logoSrc: signets.klaviyoSignet, connectDescription: "Connect to your Klaviyo account.", longDescription: "Use Klaviyo to automatically sync all customer emails. Klaviyo allows you to message past buyers and send custom cart abandonment emails.", helpCenterUrl: routing.external.helpCenter.klaviyo, recoveryActions: [
            {
                label: 'Klaviyo needs some additional permissions to sync coupons.',
                permissions: ['coupons:read', 'coupons:write', 'coupon-code:read', 'coupon-code:write'],
            },
            {
                label: 'Klaviyo needs some additional permissions to subscribe customers.',
                permissions: ['subscriptions:read', 'subscriptions:write'],
            },
        ] },
        React.createElement(AppsKlaviyoSettings, null)));
};
